export default __webpack_public_path__ + "static/media/portfolio-73.28c6eb75.jpg";